"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");

var asynciterator_1 = require("asynciterator");
/**
 * A comunica actor for joining 2 binding streams.
 *
 * Actor types:
 * * Input:  IActionRdfJoin:      The streams that need to be joined.
 * * Test:   <none>
 * * Output: IActorRdfJoinOutput: The resulting joined stream.
 *
 * @see IActionRdfJoin
 * @see IActorQueryOperationOutput
 */


var ActorRdfJoin =
/*#__PURE__*/
function (_core_1$Actor) {
  _inherits(ActorRdfJoin, _core_1$Actor);

  function ActorRdfJoin(args, maxEntries) {
    var _this;

    _classCallCheck(this, ActorRdfJoin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfJoin).call(this, args));
    _this.maxEntries = maxEntries;
    return _this;
  }
  /**
   * Returns an array containing all the variable names that occur in all bindings streams.
   * @param {IActionRdfJoin} action
   * @returns {string[]}
   */


  _createClass(ActorRdfJoin, [{
    key: "test",

    /**
     * Default test function for join actors.
     * Checks whether all iterators have metadata.
     * If yes: call the abstract getIterations method, if not: return Infinity.
     * @param {IActionRdfJoin} action The input action containing the relevant iterators
     * @returns {Promise<IMediatorTypeIterations>} The calculated estime.
     */
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action.entries.length <= 1)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", {
                  iterations: 0
                });

              case 2:
                if (!(this.maxEntries && action.entries.length > this.maxEntries)) {
                  _context.next = 4;
                  break;
                }

                throw new Error(this.name + ' supports ' + this.maxEntries + ' sources at most. The input contained ' + action.entries.length + '.');

              case 4:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 7;
                _iterator = action.entries[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 16;
                  break;
                }

                entry = _step.value;

                if (!(entry.type !== 'bindings')) {
                  _context.next = 13;
                  break;
                }

                throw new Error('Invalid type of a join entry: Expected \'bindings\' but got \'' + entry.type + '\'');

              case 13:
                _iteratorNormalCompletion = true;
                _context.next = 9;
                break;

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 22:
                _context.prev = 22;
                _context.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 25:
                _context.prev = 25;

                if (!_didIteratorError) {
                  _context.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context.finish(25);

              case 29:
                return _context.finish(22);

              case 30:
                _context.next = 32;
                return ActorRdfJoin.iteratorsHaveMetadata(action, 'totalItems');

              case 32:
                if (_context.sent) {
                  _context.next = 34;
                  break;
                }

                return _context.abrupt("return", {
                  iterations: Infinity
                });

              case 34:
                _context.next = 36;
                return this.getIterations(action);

              case 36:
                _context.t1 = _context.sent;
                return _context.abrupt("return", {
                  iterations: _context.t1
                });

              case 38:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 18, 22, 30], [23,, 25, 29]]);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
    /**
     * Returns default input for 0 or 1 entries. Calls the getOutput function otherwise
     * @param {IActionRdfJoin} action
     * @returns {Promise<IActorQueryOperationOutput>}
     */

  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(action) {
        var result, totalItems, unwrapped, oldMetadata;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(action.entries.length === 0)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", {
                  bindingsStream: new asynciterator_1.EmptyIterator(),
                  metadata: function metadata() {
                    return Promise.resolve({
                      totalItems: 0
                    });
                  },
                  type: 'bindings',
                  variables: []
                });

              case 2:
                if (!(action.entries.length === 1)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", action.entries[0]);

              case 4:
                result = this.getOutput(action);
                _context3.next = 7;
                return ActorRdfJoin.iteratorsHaveMetadata(action, 'totalItems');

              case 7:
                if (!_context3.sent) {
                  _context3.next = 14;
                  break;
                }

                totalItems = function totalItems() {
                  return Promise.all(action.entries.map(function (entry) {
                    return entry.metadata();
                  })).then(function (metadatas) {
                    return metadatas.reduce(function (acc, val) {
                      return acc * val.totalItems;
                    }, 1);
                  });
                }; // update the result promise to also add the estimated total items


                _context3.next = 11;
                return result;

              case 11:
                unwrapped = _context3.sent;

                if (unwrapped.metadata) {
                  oldMetadata = unwrapped.metadata;

                  unwrapped.metadata = function () {
                    return oldMetadata().then(
                    /*#__PURE__*/
                    function () {
                      var _ref = _asyncToGenerator(
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee2(metadata) {
                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                if (metadata.hasOwnProperty('totalItems')) {
                                  _context2.next = 4;
                                  break;
                                }

                                _context2.next = 3;
                                return totalItems();

                              case 3:
                                metadata.totalItems = _context2.sent;

                              case 4:
                                return _context2.abrupt("return", metadata);

                              case 5:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2);
                      }));

                      return function (_x3) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                  };
                } else {
                  unwrapped.metadata = function () {
                    return totalItems().then(function (t) {
                      return {
                        totalItems: t
                      };
                    });
                  };
                }

                return _context3.abrupt("return", unwrapped);

              case 14:
                return _context3.abrupt("return", result);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }], [{
    key: "overlappingVariables",
    value: function overlappingVariables(action) {
      return require('lodash.intersection').apply(this, action.entries.map(function (entry) {
        return entry.variables;
      }));
    }
    /**
     * Returns the variables that will occur in the joined bindings.
     * @param {IActionRdfJoin} action
     * @returns {string[]}
     */

  }, {
    key: "joinVariables",
    value: function joinVariables(action) {
      return require('lodash.union').apply(this, action.entries.map(function (entry) {
        return entry.variables;
      }));
    }
    /**
     * Returns the result of joining bindings, or `null` if no join is possible.
     * @param {Bindings[]} bindings
     * @returns {Bindings}
     */

  }, {
    key: "join",
    value: function join() {
      try {
        for (var _len = arguments.length, bindings = new Array(_len), _key = 0; _key < _len; _key++) {
          bindings[_key] = arguments[_key];
        }

        return bindings.reduce(function (acc, val) {
          return acc.mergeWith(function (l, r) {
            if (!l.equals(r)) {
              throw new Error();
            }

            return l;
          }, val);
        });
      } catch (e) {
        return null;
      }
    }
    /**
     * Checks if all metadata objects are present in the action, and if they have the specified key.
     * @param {IActionRdfJoin} action
     * @param {string} key
     * @returns {boolean}
     */

  }, {
    key: "iteratorsHaveMetadata",
    value: function () {
      var _iteratorsHaveMetadata = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(action, key) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", Promise.all(action.entries.map(
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4(entry) {
                    var metadata;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return entry.metadata();

                          case 2:
                            metadata = _context4.sent;

                            if (metadata.hasOwnProperty(key)) {
                              _context4.next = 5;
                              break;
                            }

                            throw new Error();

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x6) {
                    return _ref2.apply(this, arguments);
                  };
                }())).then(function () {
                  return true;
                }).catch(function () {
                  return false;
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function iteratorsHaveMetadata(_x4, _x5) {
        return _iteratorsHaveMetadata.apply(this, arguments);
      }

      return iteratorsHaveMetadata;
    }()
  }]);

  return ActorRdfJoin;
}(core_1.Actor);

exports.ActorRdfJoin = ActorRdfJoin;